<!--拆分订单-->
<template>
  <el-dialog
    title="拆单"
    :visible.sync="dialogFormVisible"
    center
    :close-on-click-modal="false" :append-to-body="true"
    custom-class="medium-dialog"
  >

    <div ref="print1" style="width: 96%;margin: 0 auto;">

      <table cellspacing="0" cellpadding="0" border="0" style="border-collapse:collapse;width:100%;"
             class="query-table">
        <tr class="noborder">
          <td align="right">订单号：</td>
          <td>{{controlData.erpserial}}</td>
          <td align="right">时&nbsp;&nbsp;间：</td>
          <td>{{controlData.htqd||controlData.adddate}}</td>
          <td align="right">仓&nbsp;&nbsp;&nbsp;&nbsp;库：</td>
          <td>
          </td>
        </tr>
        <tr class="noborder">
          <td align="right" width="60">门&nbsp;&nbsp;&nbsp;&nbsp;店：</td>
          <td width="140">{{controlData.customername}}</td>
          <td align="right" width="40">地&nbsp;&nbsp;址：</td>
          <td width="220">{{controlData.caddress}}</td>
          <td align="right" width="60">联系人：</td>
          <td width="120">{{(controlData.linkman||"")+" " +(controlData.linkmantel||"")}}</td>
        </tr>
        <tr class="noborder">
          <td align="right">服务商：</td>
          <td>{{controlData.applybydname}}</td>
          <td align="right">地&nbsp;&nbsp;址：</td>
          <td>{{controlData.address}}</td>
          <td align="right">联系人：</td>
          <td>{{(controlData.elinkman||"")+" "+(controlData.elinkmantel||"")}}</td>
        </tr>

        <tr>
          <td colspan="6" style="border:none">
            <table cellspacing="0" cellpadding="0" border="0" style="border-collapse:collapse;width:100%;"
                   class="query-table">
              <tr>
                <td v-if="item !='seedcode'&&item!='unitguid'&&item!='packagesize'&&item!='subseedcode'&&item!='formproperty'&&item!='totalmoneytax'&&item!='单价'&&item!='总价'&&item!='discount'"
                    style="text-align: center"
                    v-for="item in column">
                  {{item}}
                </td>
                <td style="text-align: center;width: 100px" >拆单数</td>

              </tr>
              <tr v-for="item in tableData" style="cursor:pointer;">
                <td
                  :style="{textAlign:ob['产品名称']?'left':'center',minWidth:ob['产品名称']?'150px':''}"
                  v-for="(ob,index) in item"
                  v-if="typeof(ob['seedcode'])=='undefined'&&typeof(ob['unitguid'])=='undefined'&&typeof(ob['packagesize'])=='undefined'&&typeof(ob['subseedcode'])=='undefined'&&typeof(ob['formproperty'])=='undefined'&&typeof(ob['单价'])=='undefined'&&typeof(ob['总价'])=='undefined'&&typeof(ob['totalmoneytax'])=='undefined'&&typeof(ob['discount'])=='undefined'&&typeof(ob['pcustomerguid'])=='undefined'&&typeof(ob['pcustomer'])=='undefined'&&typeof(ob['chaidannumber'])=='undefined'">
                  <span v-for="value in ob">{{value}}</span>
                </td>
                <td
                  v-for="(ob,index) in item"
                  v-if="typeof(ob['chaidannumber'])!='undefined'">
                  <el-input-number type="text" v-model="ob['chaidannumber']" placeholder="请输入拆单数" size="mini" @change="chaidannumber(item)"/>
                </td>
              </tr>
              <tr>
                <td v-if="item !='seedcode'&&item!='unitguid'&&item!='packagesize'&&item!='subseedcode'&&item!='formproperty'&&item!='totalmoneytax'&&item!='数量'&&item!='单价'&&item!='总价'&&item!='discount'"
                    style="text-align: center"
                    v-for="item in column">
                  {{item=='产品名称'?'合计':''}}
                </td>
                <td style="text-align: center;width: 100px" >{{totalnumber}}</td>
                <td style="text-align: center;width: 100px" >{{cdtotalnumber}}</td>

              </tr>
            </table>
          </td>
        </tr>
        <tr class="noborder">
          <td align="right">说&nbsp;&nbsp;&nbsp;&nbsp;明：</td>
          <td colspan="5" style="border: none;height: 30px">
            <div v-html="getLiuYan(controlData.remark)"></div>
          </td>
        </tr>
      </table>
    </div>
    <div slot="footer" class="dialog-footer no-print">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="primary" @click="delivergoods" class="qrbtn" :loading="loading" v-if="totalnumber>1">确定拆单</el-button>
      <el-button type="warning" @click="showDrawer" class="qrbtn" v-if="totalnumber>=200">快速拆单</el-button>
    </div>
    <el-drawer
      title="请输入拆单数量"
      :visible.sync="drawer" :wrapperClosable="false" :append-to-body="true"
      :direction="'rtl'">
      <el-row v-for="item in chaidanData" :key="item.index" style="margin-bottom: 10px">
        <span style="margin-left: 50px">{{item.index}}：</span>
        <el-input-number type="text" v-model="item.number" size="mini" :min="0" :max="totalnumber" :precision="0" @change="changeNum(item)" :controls="false" style="width: 160px"/>
      </el-row>
      <el-row style="margin-bottom: 10px;margin-top: 50px;padding-left: 80px">
        <el-button type="primary" @click="delivergoodsFast" class="qrbtn" size="mini" :loading="loading" v-if="totalnumber>=200">确定拆单</el-button>
        <el-button type="info" @click="drawer=false" size="mini" class="qrbtn">取消</el-button>
      </el-row>
    </el-drawer>
  </el-dialog>
</template>

<script>

  import {getPrice} from '@/api/set/goodsprice';
  import {printing, jxcstorelist, chaifenOrder} from '@/api/set/csagreement';
  import {getParameterDetail} from '@/api/set/parameter';
  import {getRemark} from '@/plugin/ordercommon'
  import {saveData} from '@/api/set/handlelog';

  export default {
    name: 'ChaiDan',
    data() {
      return {
        dialogFormVisible: false,
        drawer:false,
        loading: false,
        chaidanData:[],
        parameterData: [],
        deliveryaddress: '',
        formLabelWidth: '120px',
        jxcstoreData: [],
        tableData: [],
        unitguid: "",
        column: [],
        controlData: {},
        itemtemp: {},//操作某条记录的临时变量
        seedcodes: [],
        totalnumber: 0,//商品数量
        cdtotalnumber:0,
      }

    },
    methods: {
      changeNum(item) {
        var tn = this.totalnumber
        var newArr = []
        var ind = 1;
        for (let i in this.chaidanData) {
          if (tn <= 0)//拆分完成，不再继续
            break;

          var selNum = this.chaidanData[i].number;

          if (selNum != undefined && selNum && selNum > 0) {
            if (tn >= selNum) {
              newArr.push({index: ind, number: selNum})
              tn = tn - selNum;
            } else {
              newArr.push({index: ind, number: tn})
              tn = 0;
            }
            ind++;
          }
        }
        if (tn > 0)
          newArr.push({index: ind, number: tn})//剩下的都归最后一条

        this.chaidanData = []
        this.$nextTick(() => {
          this.chaidanData = newArr;
        });
      },
      showDrawer(){
        this.chaidanData=[{index:1,number:this.totalnumber}]
        this.drawer=true;
      },
      //处理日志
      handlelog() {
        var handlelog = {}
        handlelog.erpserial = this.controlData.erpserial
        handlelog.isopen = 1
        handlelog.casestepname = '拆单'
        var temp = '';
        handlelog.remark = '订单号：' + this.controlData.erpserial + temp
        saveData(handlelog).then(response => {
        })
      },
      formatTime() {
        var data = new Date();
        var year = data.getFullYear();
        var month = data.getMonth() + 1;
        var day = data.getDate();
        var hour = data.getHours();
        var minute = data.getMinutes();
        var second = data.getSeconds();
        return year + '-' + month + '-' + day + " " + hour + ":" + minute + ":" + second;
      },
      contains(item, arr) {
        for (var i = 0; i < arr.length; i++) {
          if (arr[i] == item) {
            return true;
          }
        }
        return false;
      },
      show() {
        this.dialogFormVisible = true;
      },
      chaidannumber() {
        this.cdtotalnumber = 0;
        for (let j in this.tableData) {
          var item = this.tableData[j]
          for (let i in item) {
            for (let key in item[i]) {
              if (key == 'chaidannumber'&&item[i][key]) {
                this.cdtotalnumber += parseInt(item[i][key])
              }
            }
          }
        }
      },
      getLiuYan(remark) {
        return getRemark(remark);
      },
      initData(row,initnumber) {
        this.initForm()

        this.totalnumber = 0;
        this.unitguid = row.unitguid
        printing({unitguid: row.unitguid, needunitguid: '1'}).then(response => {
          this.controlData = response.data.obj.detail;
          this.tableData = response.data.obj.goodsDetail;

          if (this.tableData.length == 0)
            return;

          //取出表头
          let temparr = []
          let biaoji = 0
          for (let i in this.tableData) {
            for (let j in this.tableData[i]) {
              if (j == "R/L") {
                biaoji = 1
              }
              if (j != "seedcode" && j != "R/L" && j != "数量" && j != "说明" && j != "关联产品" && j != "产品名称" && j != "球镜" && j != "柱镜" && j != "轴位" && !this.contains(j, temparr)) {
                temparr.push(j)
              }
            }
          }
          //对表头排序
          this.column.push("seedcode")
          if (biaoji == 1) {
            this.column.push("R/L")
          }
          this.column.push("产品名称")
          this.column.push("球镜")
          this.column.push("柱镜")
          this.column.push("轴位")
          this.column = this.column.concat(temparr)
          this.column.push("数量")
          // this.column.push("操作")

          this.tableData = this.tableData.map(o1 => this.column.map(o2 => {
            let ob = {}
            ob[o2] = o1[o2]
            return ob
          }))

          for (let j in this.tableData) {
            var item = this.tableData[j]

            var cdn = 0;
            for (let i in item) {
              for (let key in item[i]) {
                if (key == '数量') {
                  this.totalnumber += parseInt(item[i][key])
                } else if (key == 'unitguid') {

                  if (initnumber) {
                    for (let m in initnumber) {
                      if (initnumber[m].unitguid == item[i][key]) {
                        cdn = initnumber[m].stock;
                        break;
                      }
                    }
                  }

                }
              }
            }
            item.push({chaidannumber: cdn})
          }
          this.chaidannumber();
        });
      },
      delivergoodsFast() {
        var rows = []
        if (this.chaidanData.length <= 1) {//只有一个的时候不需要拆分
          this.$message({type: 'success',message: '操作成功!'});
          this.drawer=false
          this.dialogFormVisible = false;
          this.$emit("bindGrid")
          return;
        }
        this.loading = true;

        var caifenNum = this.chaidanData[0].number;
        while (caifenNum > 0) {
          for (let j in this.tableData) {
            if (caifenNum == 0)
              break;//拆分的数字获取完成 跳出循环

            var item = this.tableData[j]
            var number = 0;
            for (let i in item) {
              for (let key in item[i]) {
                if (key == '数量') {
                  number = parseInt(item[i][key])
                }
              }
            }
            if (number == 0) {
              continue;
            }
            //随机取个数字
            var rand = Math.floor(Math.random() * number);
            if (rand < 1)
              rand = 1;

            if (rand > caifenNum) {
              rand = caifenNum;
            }
            // rows.push({unitguid: unitguid, chaidannumber: rand})
            caifenNum = caifenNum - rand;
            for (let i in item) {
              for (let key in item[i]) {
                if (key == '数量') {
                  item[i][key] = number - rand;
                }
                if (key == 'chaidannumber') {
                  item[i][key] = item[i][key] + rand
                }
              }
            }
          }
        }

        var totalnums = 0;
        for (let j in this.tableData) {
          var item = this.tableData[j]
          var cbnumber = 0;
          var unitguid = 0;
          for (let i in item) {
            for (let key in item[i]) {
              if (key == 'unitguid') {
                unitguid = item[i][key];
              }
              if (key == 'chaidannumber') {
                cbnumber = parseInt(item[i][key])
                item[i][key] = 0;
              }
            }
          }
          if (cbnumber > 0) {
            rows.push({unitguid: unitguid, chaidannumber: cbnumber})
            totalnums += cbnumber
          }
        }
        this.chaidanData.splice(0, 1);//删除一条
        if (rows.length > 0)
          this.chaifen(rows, false)
        // this.drawer=false
      },
      delivergoods() {
        //提交前判断根据拆分的数量和订单的数量是否一样，都相同不可拆分订单
        if (this.cdtotalnumber == 0 || this.cdtotalnumber >= this.totalnumber) {
          this.$message({
            type: 'error',
            message: '拆分数量不正确！',
          })
          return
        }
        var rows = []
        for (let j in this.tableData) {
          var item = this.tableData[j]
          var number = 0;
          var cbnumber = 0;
          var unitguid = 0;
          for (let i in item) {
            for (let key in item[i]) {
              if (key == '数量') {
                number = parseInt(item[i][key])
              }
              if (key == 'unitguid') {
                unitguid = item[i][key]
              }
              if (key == 'chaidannumber') {
                cbnumber = parseInt(item[i][key])
              }
            }
          }
          if (cbnumber > number) {
            this.$message({
              type: 'error',
              message: '拆分数量不正确！',
            })
            return
          }
          if (cbnumber > 0)
            rows.push({unitguid: unitguid, chaidannumber: cbnumber})
        }
        if (rows.length > 0)
          this.chaifen(rows, true);
      },
      chaifen(rows,flash){
        this.loading = true;
        var item={erpserial:this.controlData.erpserial};
        chaifenOrder({
          tableData: JSON.stringify(rows),
          controlData: JSON.stringify(item)
        }).then(response => {
          if (response.data.code == 0) {
            if(flash) {
              this.$message({type: 'success',message: '操作成功!'});
              this.dialogFormVisible = false;
              this.$emit("bindGrid")
            }else{
              this.delivergoodsFast();
            }
          } else {
            this.$message.error('操作失败')
          }
        })
      },
      initForm() {
        this.loading = false;
        this.groupguid = ""
        this.column = []
        this.tableData = []
        this.unitguid = ""
        this.totalnumber = 0
        this.cdtotalnumber = 0;
        this.drawer=false;
      }
    },
    mounted() {
    },
    components: {
    }

  }
</script>

<style scoped>
  .query-table td {
    border: 1px solid #E0DFDF;
    vertical-align: center;
    height: 22px;
    line-height: 16px;
    padding: 2px;
    font-size: 12px;
  }

  .query-table td.content {
    text-align: center;
  }

  .noborder td {
    border: none;
    font-size: 12px;
  }


</style>




// WEBPACK FOOTER //
// src/components/testorder/cstagreement/CstagreementEditChaiDan.vue